<template>
  <v-container>
    <v-dialog
      persistent
      v-model="isOpen"
      @click:outside="closeDialog"
      @keydown.esc="closeDialog"
      max-width="600px"
      @keydown.ctrl="pegar"
    >
      <v-card>
        <v-card-title class="py-2">
          <span class="headline">Agregar reporte</span>
          <v-spacer></v-spacer>
          <v-btn fab small text @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="black--text">
          <br/>
          <br/>

          <!-- Datos generales -->
          <v-row>

            <v-col cols="12" lg="6">
              <label>Selecciona una escuela</label>
              <v-radio-group
                v-model="plantel"
                row
              >
                <v-radio
                  label="Inbi"
                  :value="1"
                ></v-radio>
                <v-radio
                  label="Fast"
                  :value="2"
                ></v-radio>
              </v-radio-group>

            </v-col>

            <v-col cols="12" lg="6">
              <label>Selecciona una sucursal</label>
              <v-autocomplete
                filled
                dense
                hide-details
                :items="sucursales"
                v-model="sucursal"
                label="Selecciona una sucursal"
                item-value="id_plantel"
                item-text="plantel"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12"  lg="6">
              <label>Selecciona un curso</label>
              <v-select
                :items="cursos"
                v-model="curso"
                label="Curso"
                filled
                hide-details
                dense
                item-text="curso"
                item-value="curso"
              ></v-select>
            </v-col>

            <v-col cols="12"  lg="6">
              <label>Selecciona un nivel</label>
              <v-select
                :items="niveles"
                v-model="id_nivel"
                label="Nivel"
                filled
                hide-details
                dense
                :disabled="!curso"
                item-text="nivel"
                item-value="id_nivel"
              ></v-select>
            </v-col>

            <v-col cols="12"  lg="6">
              <label>Selecciona una lección</label>
              <v-select
                v-if="curso !== 'FAST ENGLISH'"
                :items="leccionesDisponibles"
                v-model="id_leccion"
                label="Lección"
                filled
                hide-details
                dense
                :disabled="!curso"
                item-text="texto"
                item-value="valor"
              ></v-select>
              <v-text-field
                v-else
                type="number"
                label="Lección"
                filled
                hide-details
                dense
                v-model="id_leccion"
              ></v-text-field>
            </v-col>

            <v-col cols="12"  lg="6">
              <label>Diapositiva</label>
              <v-text-field
                label="Diapositiva"
                filled
                hide-details
                dense
                v-model="diapositiva"
              ></v-text-field>
            </v-col>

            <!-- Alerta aviso -->
            <v-col cols="12">
              <v-alert text dense color="blue" icon="mdi-information" border="left">
                Por favor, detalla tu problema para que se le pueda dar una solución más rápida, también, escribe que es lo que te gustaría obtener como respuesta.
              </v-alert>
            </v-col>

            <v-col cols="12">
              <v-textarea filled v-model="motivo" label="Ingrese su problema de manera detallada y clara" hide-details :rows="3" auto-grow></v-textarea>
            </v-col>

            <v-col cols="12">
              <v-file-input small-chips multiple filled v-model="files" accept="image/png, image/jpeg, image/bmp, video/mp4, video/x-m4v, video/*, application/pdf, .pdf"
                placeholder="Imágenes, videos o PDF" prepend-icon="mdi-camera" label="Evidencias" @change="cargarFotos()">
              </v-file-input>
            </v-col>

          </v-row>

        <v-row v-if="vistaPrevias.length">
          <v-col cols="12" md="3" v-for="(img, i) in vistaPrevias" :key="i">
            <v-card class="py-4 shadowCard">
              <EvidenciaMini :src="img.url" :video="!!img.video" :pdf="!!img.pdf" :nombre="img.image_name" />
              <v-btn  color="error"  small  @click="eliminarFoto(img.url)" top right absolute fab >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions v-if="plantel && sucursal && id_nivel && curso && id_leccion && diapositiva && motivo && vistaPrevias.length">
        <v-spacer></v-spacer>
        <v-btn
          :color="!estaProcesando ? 'green' : 'gray'"
          tile
          :loading="cargar"
          :disabled="cargar"
          @click="save()"
          dark
          small
          class="mb-2"
        >
          <v-icon small left>mdi-content-save</v-icon>
          {{ !estaProcesando ? 'Agregar' : 'Procesando . . .' }}
        </v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>
  </v-container>
</template>
<script>

  import axios from 'axios';
  import {mapGetters, mapActions} from 'vuex'
  import { Clipboard } from "@capacitor/clipboard";

    // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue'
  import EvidenciaMini         from '@/components/tickets/EvidenciaMini.vue'
  import { clasificarArchivoEvidencia } from '@/utils/ticketEvidencias'

  import validarErrores  from '@/mixins/validarErrores'
  export default {

    components:{
      Alerta,
      carga,
      EvidenciaMini,
    },

    mixins: [ validarErrores ],

    props: [
      'isOpen',
      'temas',
      'subtemas'
    ],

    computed:{
      ...mapGetters('login',['getdatosUsuarioERPERP']),

      leccionesDisponibles() {
        if (this.curso === 'INBI TEENS') {
          return [
            { texto: 'Lección 1', valor: 1 },
            { texto: 'Lección 2', valor: 2 },
            { texto: 'Lección 3', valor: 3 },
            { texto: 'Lección 4', valor: 4 },
            { texto: 'Lección 5', valor: 5 },
            { texto: 'Lección 6', valor: 6 },
            { texto: 'Lección 7', valor: 7 },
            { texto: 'Lección 8', valor: 8 },
            { texto: 'Examen medio término', valor: 9 },
            { texto: 'Examen final', valor: 10 }
          ]
        }

        if (this.curso === 'INBI INTENSIVO') {
          return Array.from({ length: 20 }, (_, index) => {
            const numeroLeccion = index + 1

            if (numeroLeccion === 10) {
              return { texto: 'Examen medio término', valor: numeroLeccion }
            }

            if (numeroLeccion === 20) {
              return { texto: 'Examen final', valor: numeroLeccion }
            }

            return { texto: `Lección ${numeroLeccion}`, valor: numeroLeccion }
          })
        }

        return []
      },

      niveles() {
        if (!this.curso) {
          return []
        }

        const maxNivel = this.curso === 'INBI TEENS' ? 16 : 14

        return this.nivelesTodos
          .map((item) => {
            const match = String(item.nivel).match(/^Nivel\s+(\d+)$/i)
            if (!match) {
              return null
            }

            const numero = parseInt(match[1], 10)
            if (numero < 1 || numero > maxNivel) {
              return null
            }

            return { item: item, numero: numero }
          })
          .filter((entry) => entry !== null)
          .sort((a, b) => a.numero - b.numero)
          .map((entry) => entry.item)
      }
    },

    watch: {
      curso() {
        this.id_leccion = null
        this.id_nivel = 0
      }
    },

    data: () => ({
      respuestaAlerta:false,
      cargar: false,
      estaProcesando: false,
      urgente: 0,
      url:'',

      fotos:[],
      files: [],
      vistaPrevias:[],

      area: null,
      motivo: "",
      motivo_aux: "",
      plantel: null,
      planteles: [
        { id_plantel: 1, plantel: "INBI" },
        { id_plantel: 2, plantel: "FAST ENGLISH" },
      ],

      sucursales:[],
      sucursal: null,

      id_leccion: null,
      diapositiva: '',

      areas:[],
      area: null,

      puestos:[],
      puesto:null,

      jefes:[],
      jefe: null,

      show_folio: false,

      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      idtemas_tickets: null,
      idsubtemas_tickets: null,
      otro_motivo:null,

      opContieneAlumno: null,

      alumno: null,
      grupo: null,
      grupos:[],
      alumnos: [],
      headersAlumnos:[
        { text: 'matricula', value: "matricula" },
        { text: 'alumno'   , value: "alumno" },
        { text: 'grupo'    , value: "grupo" },
      ],

      searchAlumno:'',
      alumnos_ticket:[],
      infoSubtema: null,
      requiere_ticket: true,
      panel: null,
      evidencia_requerida: '',

      ruta: [],
      estado: null,
      problemas: [],

      dialogSoporteTecnico: false,

      nivelesTodos: [],
      cursos:[
        {
          id: 0,
          curso: 'INBI TEENS'
        },
        {
          id: 1,
          curso: 'INBI INTENSIVO'
        },
        {
          id: 2,
          curso: 'FAST ENGLISH'
        }
      ],

      id_nivel: 0,
      curso: 0,

    }),

    async created() {
      var url = axios.defaults.baseURL + 'evidencia-tickets/'
      this.initialize( )
      await this.getNiveles()
    },

    methods: {

      initialize () {
        this.sucursales = []
        this.cargar = true
        this.$http.get("sucursales.all").then(response=>{
          this.sucursales = response.data
          this.cargar     = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      closeDialog(){
        this.limpiarFormulario()
        this.$emit('close');
      },

      getNiveles () {
        this.cargar = true
        this.nivelesTodos = []
        return this.$http.get('niveles.activos').then(response=>{
          this.nivelesTodos = response.data
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      async save() {

        if( this.estaProcesando ) return

        this.puesto = { idpuesto : 48 }
        this.jefe   = { id_usuario : 32 }


        this.cargar = true
        let fotos = []

        if(this.vistaPrevias.length){
          let respuesta = await this.subirFotosServidor( )
          fotos = respuesta.data
        }

        let usuario_id = null

        if( this.idsubtemas_tickets ){

          const existesubtema = this.subtemas.find( el => el.idsubtemas_tickets == this.idsubtemas_tickets )

          usuario_id = existesubtema ? existesubtema.id_usuario  : 0

        }

        var payload = {
          id_unidad_negocio: this.plantel,
          id_area          : this.puesto.idpuesto,
          idjefe_area      : this.jefe.id_usuario,
          motivo           : this.motivo,
          estatus          : 2,
          id_usuario       : this.getdatosUsuarioERPERP.iderp,
          tipousuario      : 0,
          id_suc           : this.sucursal,
          urgente          : this.urgente == true ? 1 : 0,
          fotos,
          idtemas_tickets   : 22,
          idsubtemas_tickets: 52,
          otro_motivo       : this.otro_motivo,
          alumnos           : this.alumnos_ticket,
          curso             : this.curso,
          id_nivel          : this.id_nivel,
          nivel             : (this.niveles.find(n => n.id_nivel === this.id_nivel) || {}).nivel,
          id_leccion        : this.id_leccion,
          diapositiva       : this.diapositiva
        };

        this.estaProcesando = true;

        this.$http.post("tickets.add", payload).then((response) => {
          this.folio               = response.data.ticket.id;
          this.idhistorial_ticket  = response.data.historial.id;
          this.otro_motivo         = null
          this.motivo_aux = this.motivo;
          this.show_folio = true;
          this.limpiarFormulario()
          this.validarSuccess( response.data.message )
          this.$emit('recargar')
          this.$emit('close')
        }).catch( error =>{
          this.estaProcesando = false;
          this.validarError( error.response.data.message )
        }).finally( () => {
          this.estaProcesando = false;
          this.cargar = false
        })
      },

      limpiarFormulario() {
        this.plantel = null
        this.motivo = ''
        this.sucursal = null
        this.urgente = 0
        this.vistaPrevias = []
        this.files = []
        this.curso = 0
        this.id_nivel = 0
        this.id_leccion = null
        this.diapositiva = ''
      },

      saveResultado( ){
        this.alumnos_ticket.push({
          ...this.alumno,
          ...this.grupo
        })
      },

      subirFotosServidor( ){
        let formData = new FormData();

        for( const i in this.vistaPrevias ){
          formData.append('file', this.vistaPrevias[i].file )
        }

        return new Promise((resolve,reject)=>{
                // obtener la extensión del archivo
                // Hacemos la petición
          this.$http.post(`tickets.subir.evidencia`, formData ).then(response=>{
            resolve( response )
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        })
      },

      cargarFotos(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
                // creamos una variable tipo FormData
          let formData = new FormData();
                //se crea el objeto y se le agrega como un apendice el archivo
          formData.append('file', element);
                //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
                if(element.size > 26214400){ //26214400 = 25MB
                  console.log(element.size)
                  this.validarErrorDirecto('El archivo sobrepasa el limite del peso, max 25 MB')
                } else {
                  this.getBase64(element, formData)
                }
              })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          const tipoArchivo = clasificarArchivoEvidencia(file.name)
          me.vistaPrevias.push({
            url: reader.result,
            formData: formData,
            image_name: file.name,
            video : tipoArchivo.video,
            pdf: tipoArchivo.pdf,
            file
          })
        };
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },

      convertFile(dataurl, filename) {
        var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
      },

      createFile(file) {
        if (file.size > 10000000) {
          alert("please check file size no over 5 MB.");
          this.dragging = false;
          return;
        }

        this.file = file;
        this.archivos = file;
        this.getBase64(this.archivos);
        this.dragging = false;
      },

      async pegar(event) {
        if (event.code == "KeyV") {
          const { type, value } = await Clipboard.read();

                    // Validamos que sea de tipo imagen
          if (type == "image/png") {
                    // Convertimos el base64 en una imagen
            const file = this.convertFile(value, "imagen.png");
            this.createFile(file);
          }
        }
      },


      async getSoporte () {

        this.cargar = true

        this.$http.get('soporte.problemas').then(response=>{

          this.cargar = false

          this.problemas = response.data

          console.log( this.problemas )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })

      },

      seleccionarRespuesta (id) {
        this.ruta.push(id)
        this.getSoporte()
      },

      reiniciar () {
        this.ruta = []
        this.estado = null
      },

      iniciarChat( id ){
        this.cargar = true

        this.ruta.push( id )

        this.$http.post('soporte.chat', this.ruta ).then(response=>{

          this.cargar = false

          this.estado = response.data

          console.log( this.estado )

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      }

    },
  }

</script>
